// import VT from '@/store/types';

export default {
  // [VT.IDENTITIES_LIST]: (state, { data, status }) => {
  //   state.identitiesList = { data, status };
  // },
};
